import * as React from 'react'
import { Margin } from 'web-makeup/dist/design-system/styles/spacings'
import { Text } from 'web-makeup/dist/design-system/styles/typography'
import { redirect } from 'web-ui/dist/helpers/redirect'

import { numberWithCommas } from '../../helpers/priceFormater'

import { Container, Thumbnail, Info, Price } from './PurchaseProduct.style'

const PurchaseProduct: React.FC = () => {
  const [responseData, setResponseData] = React.useState<any>([])
  const [currentProduct, setCurrentProduct] = React.useState<any>(null)

  React.useEffect(() => {
    fetch('https://90seconds.com/json-product/')
      .then(response => response.json())
      .then(json => {
        json && setResponseData(json)
      })
      .catch(err => {
        err && console.error(err)
      })
  }, [])

  React.useEffect(
    () => {
      const pageUrl = new URL(window.location.href)
      const productSlug = pageUrl.searchParams.get('product')
      const filteredProduct =
        responseData && responseData.find(product => product.link.indexOf(productSlug) !== -1)
      setCurrentProduct(filteredProduct)
    },
    [responseData]
  )
  const priceArray = currentProduct && currentProduct.price && currentProduct.price.split('\n', 2)
  const hasNotApprox = currentProduct && currentProduct.price && currentProduct.price.includes('\n')
  return (
    <>
      {currentProduct && (
        <>
          <Container>
            <Info>
              <Thumbnail thumb={currentProduct.small_image} />
              <div>
                <Text as="h4" fontSize="h5" color="black1">
                  Selected product
                </Text>
                <Text as="h4" fontSize="h1" color="black1" fontWeight="black">
                  {currentProduct.product}
                  <Text
                    as="span"
                    fontSize="h5"
                    color="adaptBlue"
                    fontWeight="bold"
                    onClick={() => currentProduct.link && redirect(currentProduct.link)}
                  >
                    Change
                  </Text>
                </Text>
              </div>

              <Text
                className="mobileChange"
                as="span"
                fontSize="h5"
                color="adaptBlue"
                fontWeight="bold"
                onClick={() => currentProduct.link && redirect(currentProduct.link)}
              >
                Change
              </Text>
            </Info>
            <Price>
              {!hasNotApprox && <span>Approx.</span>}
              <Text
                as="h4"
                fontSize="h1"
                color="black1"
                fontWeight="black"
                style={{ marginRight: '0.25rem' }}
              >
                <Text as="span" fontSize="h4" color="black1" style={{ marginRight: '0.25rem' }}>
                  USD
                </Text>
                {priceArray &&
                  priceArray.map((price, index) => (
                    <span key={index}>
                      {index === 1 && ` - `}${numberWithCommas(price)}
                    </span>
                  ))}
              </Text>
            </Price>
          </Container>
          <Margin size="medium" bottom />
        </>
      )}
    </>
  )
}

export default PurchaseProduct



// WEBPACK FOOTER //
// ./src/components/PurchaseProduct/PurchaseProduct.tsx